<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"> </ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<ng-template #modalPagoPlan let-d="dismiss" let-c="close">
	<div class="modal-xl">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div *ngIf="!currentEmisorObject" class="modal-wizard-title">Renovar plan</div>
				<div *ngIf="currentEmisorObject" class="modal-wizard-title">Renovar plan para la empresa {{currentEmisorObject.razonSocial}}</div>
				<div class="modal-wizard-desc">Seleccione según corresponda</div>
			</div>
		</div>
		<div class="modal-body">
			<app-deuda-gracia-card
				*ngIf="tieneDeudaGraciaPendiente"
				[deuda]="deudaGraciaPendiente"
				[pagando]="pagandoDeudaGracia"
				mensaje="Debes pagar primero el uso realizado durante el periodo de gracia. Después podrás renovar tu plan desde la fecha del nuevo pago."
				(pagar)="pagarDeudaGracia()">
			</app-deuda-gracia-card>
			<app-deuda-adicional-card
				*ngIf="tieneDeudaAdicionalPendiente"
				[deuda]="deudaAdicionalPendiente"
				[pagando]="pagandoDeudaAdicional"
				(pagar)="pagarDeudaAdicional()">
			</app-deuda-adicional-card>
			<div class="row mt-4">
				<div class="col-8">
					<app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'blocked'" [planSeleccionado]="planSeleccionado" [planUsuario]="planActual" (actualizarPlan)="updatePlan($event)"></app-planes-bloque>
					<div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
						<div class="card-body">
							<p class="mr-2">Datos para emisión de la factura:</p>
							<div *ngIf="datosFacturacion">
								<div class="row">
									<div class="col-5">
										<ng-select class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="datosFacturacion"> </ng-select>
									</div>
									<div class="col-7">
										<div class="ml-4" style="display: flex">
											<div>
												<p>RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
												<p>Comuna: {{ datosFacturacion.comuna }}</p>
												<p>Giro: {{ datosFacturacion.giro }}</p>
											</div>
											<div class="ml-4">
												<p>Razón Social: {{ datosFacturacion.razonSocial }}</p>

												<p>Dirección: {{ datosFacturacion.dirFact }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark" data-plugin-sticky data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
						<div class="card-body" *ngIf="nuevaFechaCaducidad">
							<p *ngIf="!planActual.isDemo && !resumenCuenta?.esReactivacion">
								Tu plan actual terminó el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. Su nueva vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong
								>. El tiempo se calcula desde el vencimiento de tu plan.
							</p>
							<p *ngIf="planActual.isDemo">
								Tu plan gratuito terminó el {{ planActual.fechaCaducidad | date : "dd/MM/y" }}. La vigencia sera desde <strong>{{ fechaActual.toString() | date : "dd/MM/y" }}</strong> (hoy) hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}.</strong
								>
							</p>
							<p *ngIf="resumenCuenta?.esReactivacion">
								Tu nueva vigencia comenzará con este pago y se extenderá hasta el <strong>{{ nuevaFechaCaducidad.format("DD/MM/YYYY") }}</strong>.
							</p>
							<p *ngIf="nuevaFechaCaducidad.isBefore(fechaActual) && !planActual.isDemo && !resumenCuenta?.esReactivacion" style="color: red">Con este pago regularizas tu plan, pero aún mantendrías una mora de {{ nuevaFechaCaducidad.diff(fechaActual, "days") * -1 }} días.</p>
							<p *ngIf="resumenCuenta && resumenCuenta.proporcional > 0">El valor total del plan tiene un cobro adicional de {{ resumenCuenta.proporcional | currency : "$ " : "symbol" : "1.0-0" : "es" }} que corresponde al proporcional del plan desde el {{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} hasta el {{ nuevaFechaCaducidad.format("DD/MM/YYYY")}}. Es decir, su plan por {{resumenCuenta.meses}} meses terminaría el {{resumenCuenta.fechaInicioProporcional | date: "dd/MM/yyyy"}} pero se agregó el cobro proporcional para cerrar el ciclo de facturación el día {{nuevaFechaCaducidad.format("DD/MM/YYYY")}}</p>
						</div>
					</div>
				</div>
				<div class="col-4">
					<app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado" [planes]="planes" [certificaciones]="certificaciones" [type]="'extend'" [planUsuario]="planActual" (actualizarResumen)="notifyResumen($event)"></app-resumen-bloque>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div style="display: flex; align-items: center; flex-flow: row">
				<small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el pago.</small>
				<button *ngIf="emisoresSource.length > 1" type="button" class="btn ml-4 btn-info" (click)="openCambiarEmpresa(false)">Cambiar de empresa</button>
				<button type="button" class="btn ml-4 btn-primary"
						[disabled]="loading || solicitandoFechaCertificacion || tieneDeudaGraciaPendiente || tieneDeudaAdicionalPendiente"
						[ngbTooltip]="tieneDeudaGraciaPendiente ? 'Primero debes pagar el uso del periodo de gracia.' : (tieneDeudaAdicionalPendiente ? 'No puedes pagar el plan porque tienes deuda de adicionales. Paga la deuda primero.' : '')"
						(click)="pagar()">Renovar y pagar</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #modalCambiarEmpresa let-d="dismiss" let-c="close">
    <div class="modal-xl">
        <div class="modal-header">
            <div class="modal-wizard-label">
                <div class="modal-wizard-title">Cambiar de empresa</div>
                <div class="modal-wizard-desc">Seleccione según corresponda</div>
            </div>
        </div>
        <div class="modal-body">
            <div *ngIf="tieneEmpresasInactivas" class="alert  d-flex align-items-center mb-3" role="alert">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                <div>
					Tienes <strong>{{ cantidadEmpresasInactivas }} empresa(s) con planes sin vigencia</strong>.
					Selecciónalas para renovar o contratar un plan.
                </div>
            </div>

            <ng-select
                data-testid="blocked-company-selector"
                [items]="emisoresSource"
                placeholder="Seleccione una empresa"
                (change)="onEmpresaSeleccionada($event)"
                [(ngModel)]="currentEmisorObject"
                [clearable]="false"
                [searchable]="true"
                bindLabel="razonSocial">

                <ng-template ng-option-tmp let-item="item">
                    <div
                        class="empresa-option"
                        [class.empresa-option--inactiva]="!item.activo"
                        [attr.data-testid]="'blocked-company-option-' + item.emisorId"
                        [attr.data-rut]="item.rut">
                        <div class="empresa-option__info">
                            <span class="empresa-option__nombre">{{ item.razonSocial }}</span>
                            <small class="empresa-option__rut text-muted ml-2">{{ item.rutString }}</small>
                        </div>
                        <span *ngIf="item.activo" class="badge-estado badge-estado--activa">
                            <i class="fas fa-check-circle mr-1"></i>Activa
                        </span>
                        <span *ngIf="!item.activo" class="badge-estado badge-estado--inactiva">
                            <i class="fas fa-ban mr-1"></i>Desactivada
                        </span>
                    </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    <div class="empresa-label-selected">
                        <span>{{ item.razonSocial }}</span>
                        <span *ngIf="item.activo" class="badge-estado badge-estado--activa ml-2">
                            <i class="fas fa-check-circle mr-1"></i>Activa
                        </span>
                        <span *ngIf="!item.activo" class="badge-estado badge-estado--inactiva ml-2">
                            <i class="fas fa-ban mr-1"></i>Desactivada
                        </span>
                    </div>
                </ng-template>

            </ng-select>
        </div>
    </div>
</ng-template>
